// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';

// import utils
import displayUtils from '../../../global/utils/displayUtils';

const UserProfilePic = ({
  user
  , classes
}) => {
  return (
    <div className={`user-initials ${classes}`}>
      {displayUtils.getUserInitials(user)}
    </div>
  )
}

UserProfilePic.propTypes = {
  user: PropTypes.object.isRequired
  , classes: PropTypes.string
}

export default UserProfilePic;



// WEBPACK FOOTER //
// modules/user/components/UserProfilePic.js.jsx